import React, { useState, useEffect } from 'react';
import {
  Container,
  Stack,
  Typography,
  Button,
  TextField,
  Autocomplete,
  Card,
} from '@mui/material';
import api from '../../api';
import { toast } from 'react-toastify';

const PAYMENT_TYPES = [
  { label: 'Without To Pay', value : 'Without To Pay' },
  { label: 'To Pay', value: 'To Pay' },
  { label: 'Both', value: 'Both' },
  { label: 'Cash', value: 'Cash' }

];




const GenerateBillComponent = () => {
  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState({
    dateFrom: '',
    dateTo: '',
    paymentType: 'Without To Pay',
    clientId: '',
    clientName: ''
  });
  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      const response = await api.get('/api/v1/clients');
      if (response.data.success) {
        const clientsData = response.data.clients.map((item) => ({
          label: `${item.name} (${item.gstNo})`,
          value: item,
          id: item.id
        }));
        clientsData.push({ label: 'General', value: null, id: 'General' });
        setClients(clientsData);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error('Something went wrong!');
    }
  };

  const onChangeSearch = (event) => {
    setSearch(prev => ({ ...prev, [event.target.name]: event.target.value }));
  };

  const onClickGenerateBill = async () => {
    try {
      const response = await api.post('/api/v1/billing', search);
  
      if (response.data.success) {
        toast.success(response.data.message);
  
        // ✅ Extract Base64 PDF string
        const pdfBase64 = response.data.pdf;
  
        if (pdfBase64) {
          // Convert Base64 to binary
          const byteCharacters = atob(pdfBase64);
          const byteNumbers = new Array(byteCharacters.length)
            .fill()
            .map((_, i) => byteCharacters.charCodeAt(i));
          const byteArray = new Uint8Array(byteNumbers);
  
          // Create a Blob from the bytes
          const blob = new Blob([byteArray], { type: 'application/pdf' });
  
          // Create a download link
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
  
          // Set filename dynamically (optional)
          link.download = `Billing_${new Date().toISOString().slice(0, 10)}.pdf`;
          document.body.appendChild(link);
          link.click();
  
          // Cleanup
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      } else if (response.data.success === false) {
        toast.error(response.data.message);
      } else {
        toast.error('Something went wrong!');
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to generate bill.');
    }
  };
  

  const onClientChange = (event, values) => {
    if (!values) return;
    setSearch(prev => ({ ...prev, clientId: values.id, clientName: values.label }));
  };
  const onClickPaymentType = (event, values) => {
    if (!values) return;
    setSearch(prev => ({ ...prev, paymentType: values.value }));
  };

  return (
    <><Container maxWidth={false}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
        <Typography variant="h4" gutterBottom>
          Generate Bill
        </Typography>
      </Stack>
      <Card style={{ marginBottom: "30px", padding: "20px", height: "100vh" }}>
          <Stack direction="row" sx={{ my: 2 }} spacing={2}>
          <Autocomplete
              disablePortal
              id="sender-autocomplete"
              options={clients}
              style={{ marginRight: "10px" }}
              onChange={onClientChange}
              fullWidth
              value={clients.find(client => client.label === search.clientName) || null}
              getOptionLabel={(option) => option.label || ''}
              isOptionEqualToValue={(option, value) => option.label === value?.label}
              renderInput={(params) => <TextField  {...params} label="Select Client" />}
            />
              <TextField
                  label="Date From"
                  name="dateFrom"
                  type="date"
                  variant="outlined"
                  size="md"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  onChange={onChangeSearch}

              />
              <TextField
                  label="Date To"
                  name="dateTo"
                  type="date"
                  variant="outlined"
                  size="md"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  onChange={onChangeSearch}

              />
              <Autocomplete
                        disablePortal
                        disableClearable
                        id="package-type-autocomplete"
                        options={PAYMENT_TYPES}
                        style={{ marginRight: "10px" }}
                        onChange={onClickPaymentType}
                        onKeyDown={(e) => e.preventDefault()}
                        fullWidth
                        value={PAYMENT_TYPES.find((type) => type.label === search.paymentType) || PAYMENT_TYPES[0]}
                        getOptionLabel={(option) => option.label || ''}
                        isOptionEqualToValue={(option, value) => option.label === value?.label}
                        renderInput={(params) => <TextField {...params} label="Select Payment Type" />}
                    />
             
             
          </Stack>
          <Stack direction="row" justifyContent="center" sx={{ mt: 20 }}>
              <Button variant="contained" onClick={onClickGenerateBill} sx={{ size: "md" }}>Generate </Button>
             
          </Stack>
      </Card>
            </Container>
        </>
    );
};

export default GenerateBillComponent;
